import { createStore } from 'stimulus-store';

export const printClassStore = createStore({
    name: 'printClassStore',
    type: Object,
    initialValue: {}
});